export interface RewardsToasterOption {
    top?: string;
    class?: string;
}

export interface RewardsToasterArgs {
    message: string;
    type: RewardsToasterType;
    continueCb?: () => void;
    closeCb?: () => void;
}

export interface RewardsToasterData {
    message?: string;
    title?: string;
    type: RewardsToasterType;
    autoCloseTime?: number;
}

export enum RewardsToasterType {
    Success = 'Success',
    Error = 'Error',
    CompletelyExpired = 'CompletelyExpired',
    PartiallyExpired = 'PartiallyExpired',
    SuccessGoToRewards = 'SuccessGoToRewards',
    Information = "Information"
}

export interface RewardsToasterEvent {
    type: string,
    data?: any,
}
